var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-button-toolbar",
        [
          _vm.showItemActions
            ? _c(
                "b-button-group",
                { staticClass: "mr-3" },
                [
                  _c(
                    "ButtonOutline",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: { title: "Show on canvas" },
                      on: { click: _vm.showOnCanvas },
                    },
                    [_c("i", { staticClass: "fas fa-crosshairs" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "ButtonOutline",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: { title: "Replace" },
                      on: { click: _vm.handleReplace },
                    },
                    [_c("i", { staticClass: "fas fa-redo-alt" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "ButtonOutline",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: { title: "Delete" },
                      on: { click: _vm.handleDelete },
                    },
                    [_c("i", { staticClass: "fas fa-trash" })]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-button-group",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.mode === _vm.MODES.VIEW,
                  expression: "mode === MODES.VIEW",
                },
              ],
              staticClass: "mr-3",
            },
            [
              _c(
                "ButtonOutline",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true },
                    },
                  ],
                  class: _vm.isFolderViewEnabled ? "active" : "",
                  attrs: { title: "Folder view" },
                  on: { click: _vm.toggleFolderView },
                },
                [
                  _c("b-icon", {
                    attrs: { icon: "folder-check", "aria-hidden": "true" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ButtonOutline",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true },
                    },
                  ],
                  class: _vm.grouped ? "active" : "",
                  attrs: { title: "Grouped view" },
                  on: { click: _vm.toggleGroupMode },
                },
                [_c("i", { staticClass: "fas fa-layer-group" })]
              ),
              _vm._v(" "),
              _vm.currentBrowserType === "regular" &&
              _vm.isOtherSourcesAvailable
                ? _c(
                    "ButtonOutline",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: { title: "Salsify" },
                      on: { click: _vm.enableSalsifyBrowserMode },
                    },
                    [
                      _c("b-icon", {
                        attrs: {
                          icon: "cloud-arrow-down",
                          "aria-hidden": "true",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentBrowserType === "salsify" &&
              _vm.isOtherSourcesAvailable
                ? _c(
                    "ButtonOutline",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: { title: "Products" },
                      on: { click: _vm.enableBrowserMode },
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: "grid", "aria-hidden": "true" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "ButtonOutline",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true },
                    },
                  ],
                  attrs: { title: "Fetch by ID" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("toggle-fetch-modal")
                    },
                  },
                },
                [_c("i", { staticClass: "fas fa-link" })]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.mode !== _vm.MODES.VIEW,
                  expression: "mode !== MODES.VIEW",
                },
              ],
            },
            [
              _c(
                "ButtonOutline",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true },
                    },
                  ],
                  staticClass: "cancel-button mr-2",
                  attrs: { title: "Cancel" },
                  on: { click: _vm.goBackToView },
                },
                [
                  _c("b-icon", {
                    attrs: { icon: "x-circle-fill", "aria-hidden": "true" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ButtonOutline",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true },
                    },
                  ],
                  staticClass: "mr-2",
                  class: _vm.isFolderViewEnabled ? "active" : "",
                  attrs: {
                    title: "Folder view",
                    disabled: _vm.currentBrowserType === "salsify",
                  },
                  on: { click: _vm.toggleFolderView },
                },
                [
                  _c("b-icon", {
                    attrs: { icon: "folder-check", "aria-hidden": "true" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.currentBrowserType === "regular" &&
              _vm.isOtherSourcesAvailable
                ? _c(
                    "ButtonOutline",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "mr-2",
                      attrs: { title: "Salsify" },
                      on: { click: _vm.enableSalsifyBrowserMode },
                    },
                    [
                      _c("b-icon", {
                        attrs: {
                          icon: "cloud-arrow-down",
                          "aria-hidden": "true",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentBrowserType === "salsify" &&
              _vm.isOtherSourcesAvailable
                ? _c(
                    "ButtonOutline",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "mr-2",
                      attrs: { title: "Products" },
                      on: { click: _vm.enableBrowserMode },
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: "grid", "aria-hidden": "true" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "ButtonOutline",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true },
                    },
                  ],
                  attrs: { title: "Fetch by ID" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("toggle-fetch-modal")
                    },
                  },
                },
                [
                  _c("b-icon", {
                    attrs: { icon: "link", "aria-hidden": "true" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }